import {Routes, Route, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core/PageData'

import {useIntl} from 'react-intl'
import {UserManagedEvents} from './UserManagedEvents'
import { EventsNeverClosed } from './EventsNeverClosed'
import { EvenstClosingTime } from './EvenstClosingTime'

const OperationRankingRoutes = () => {
  const intl = useIntl()
  const breadcrumbs: Array<PageLink> = [
    {
      title: 'Arteco Insight',
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({id: 'MENU.OPERATION_RANKING'}),
      path: '',
      isSeparator: false,
      isActive: false,
      disableLink: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  
  return (
    <Routes>
      <Route
        path='user-managed-events'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.OPERATION_RANKING.USER_MANAGED_EVENTS'})}
            </PageTitle>
            <UserManagedEvents />
          </>
        }
      />
      <Route
        path='events-never-closed'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.OPERATION_RANKING.EVENTS_NEVER_CLOSED'})}
            </PageTitle>
            <EventsNeverClosed />
          </>
        }
      />
    
      {/* <Route
        path='events-closing-time'
        element={
          <>
            <PageTitle breadcrumbs={breadcrumbs}>
              {intl.formatMessage({id: 'MENU.OPERATION_RANKING.EVENTS_CLOSING_TIME'})}
            </PageTitle>
            <EvenstClosingTime />
          </>
        }
      /> */}
   
      <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
  )
}

export {OperationRankingRoutes}
